export default {
    unavailable: 'unavailable',
    pending: 'pending',
    loaded: 'loaded'
}
